import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import HomePage from '../../features/home/HomePage'
import { Container } from 'semantic-ui-react'
import NavBar from '../../features/nav/NavBar';
import NotFound from '../layout/NotFound';
import ReprogramacionForm from '../../features/reprogramacion/form/ReprogramacionForm';
import PuntosPagoInfo from '../../features/reprogramacion/info/PuntosPagoInfo';

const Routes = ({ location }) => {
    return (
        <>
            <Route exact path='/' component={HomePage} />
            <Route
                path={'/(.+)'}
                render={() => (
                    <>
                        <NavBar />
                        <Container style={{ marginTop: '7em' }}>
                            <Switch>
                                <Route exact path='/' component={HomePage} />
                                <Route exact path='/reprogramar' component={ReprogramacionForm} />
                                <Route exact path='/puntos-pago' component={PuntosPagoInfo} />
                                <Route
                                    component={NotFound}
                                />
                            </Switch>
                        </Container>
                    </>
                )}
            />
        </>

    )
}

export default withRouter(Routes);
